import { ResourceParentType } from '@greatmindsorg/dp-assignments-sdk/dist/engine/dtos/resource-parent-detail.dto';
export interface CmsCurriculum {
  id: string;
  description?: string;
  internalId?: string;
  title?: string;
  sequencer?: number;
  type?: string;
  product?: string;
  studentsDisplayedTitle?: string;
  curriculumLogo?: string;
  forStudents?: boolean;
  requiredLicensePolicies: Array<CmsLicensePolicy>;
}
export interface CmsCourse {
  id: string;
  internalId?: string;
  description?: string;
  title?: string;
  forStudents?: boolean;
  headerImage?: string;
  headerImageAlternativeText?: string;
  headerImageCaption?: string;
  requiredLicensePolicies: Array<CmsLicensePolicy>;
}
export interface CmsModule {
  id: string;
  internalId?: string;
  title?: string;
  description?: string;
  forStudents?: boolean;
  requiredLicensePolicies: Array<CmsLicensePolicy>;
}
export interface CmsTopic {
  id: string;
  internalId?: string;
  title?: string;
  description?: string;
  forStudents?: boolean;
  requiredLicensePolicies: Array<CmsLicensePolicy>;
}
export interface CmsLesson {
  id: string;
  internalId?: string;
  title?: string;
  description?: string;
  forStudents?: boolean;
  requiredLicensePolicies: Array<CmsLicensePolicy>;
}
export interface CmsResource extends CmsHasLabels {
  id: string;
  title?: string;
  internalId?: string;
  description?: string;
  components: Array<CmsResourceComponent>;
  forStudents?: boolean;
  assignable?: boolean;
  shareable?: boolean;
  requiredLicensePolicies: Array<CmsLicensePolicy>;
}
export enum ResourceType {
  Assessment = 'resources.assessment',
  File = 'resources.file',
  Video = 'resources.video',
  Image = 'resources.image',
  Link = 'resources.link',
  DigitalInteractive = 'resources.digital-interactive',
  Invalid = 'resources.invalid',
}
export interface CmsBaseResourceComponent {
  componentType: ResourceType;
  language: string | null;
  parentId?: string | null;
  parentType?: ResourceParentType | null;
  resourceId?: string | null;
}
export interface CmsAssessmentResourceComponent extends CmsBaseResourceComponent {
  componentType: ResourceType.Assessment;
  assessmentId: string | null;
  type: string | null;
  alternativeTitle: string | null;
}
export interface CmsFileResourceComponent extends CmsBaseResourceComponent {
  componentType: ResourceType.File;
  alternativeText: string | null;
  caption: string | null;
  alternativeTitle: string | null;
  downloadable: boolean | null;
  name: string | null;
  mime: string | null;
  ext: string | null;
  url: string | null;
  presentationType: FilePresentationType | null;
}
export enum FileContentType {
  pdf,
  ppt,
  unsupported,
}
export enum FilePresentationType {
  None = 'none',
  GeodesFlipbook = 'Flipbook',
}
export interface CmsLinkResourceComponent extends CmsBaseResourceComponent {
  componentType: ResourceType.Link;
  contentReference: string | null;
  targetApp: string | null;
  alternativeTitle: string | null;
}
export interface CmsImageResourceComponent extends CmsBaseResourceComponent {
  componentType: ResourceType.Image;
  author: string;
  year: string;
  description: string;
  downloadable: boolean;
  copyrightText: string;
  altText: string;
  name: string;
  mime: string;
  ext: string;
  url: string;
}
export interface CmsVideoResourceComponent extends CmsBaseResourceComponent {
  componentType: ResourceType.Video;
  videoId: string | null;
  alternativeTitle: string | null;
}
export interface CmsDigitalInteractiveComponent extends CmsBaseResourceComponent {
  componentType: ResourceType.DigitalInteractive;
  url: string | null;
  year: string | null;
  copyrightText: string | null;
}
export type CmsResourceComponent = CmsAssessmentResourceComponent | CmsFileResourceComponent | CmsLinkResourceComponent | CmsImageResourceComponent | CmsVideoResourceComponent | CmsDigitalInteractiveComponent;
interface CmsLabel {
  id: string;
  label?: string;
  description?: string;
}
export interface CmsLicensePolicy {
  id: string;
  title?: string;
  type?: string;
  collections: Array<{
    id: string;
    internalId?: string;
    description?: string;
    collectionType?: string;
  }>;
}
export interface CmsResourceIdentifier {
  internalId: string;
  collectionType: string;
  collectionUUID: string;
  resourceUUID: string;
}
export interface CmsCollectionResponse {
  data: any;
  previousLink?: string;
  nextLink?: string;
}
export interface CmsCollection<ItemType> {
  data: Array<ItemType>;
  getNextPage?: () => Promise<CmsCollection<ItemType>>;
  getPreviousPage?: () => Promise<CmsCollection<ItemType>>;
}
export enum ItemTypeName {
  Curriculum = 'Curriculum',
  Course = 'Course',
  Module = 'Module',
  Topic = 'Topic',
  Lesson = 'Lesson',
  Resource = 'Resource',
}
interface CmsItemResponse<ItemType, ChildType> {
  parentDataType: ItemTypeName;
  parentData: ItemType;
  childrenDataType?: ItemTypeName;
  childrenData: ChildType extends void ? [] : Array<ChildType>;
}
export interface CmsHasLabels {
  labels: Array<CmsLabel>;
}
export interface CmsHasResources {
  resources: Array<CmsResource>;
}
export interface CmsGenericItemResponse {
  parentDataType: ItemTypeName;
  parentData: {
    id: string;
    resources?: Array<CmsResource>;
  };
  childrenDataType?: ItemTypeName;
  childrenData?: Array<{
    id: string;
  }>;
}
export type CmsCurriculaResponse = Array<CmsCurriculum>;
export type CmsCurriculumResponse = CmsItemResponse<CmsCurriculum & CmsHasLabels, CmsCourse>;
export type CmsCourseResponse = CmsItemResponse<CmsCourse & CmsHasLabels & CmsHasResources, CmsModule>;
export type CmsModuleResponse = CmsItemResponse<CmsModule & CmsHasLabels & CmsHasResources, CmsTopic>;
export type CmsTopicResponse = CmsItemResponse<CmsTopic & CmsHasLabels & CmsHasResources, CmsLesson>;
export type CmsLessonResponse = CmsItemResponse<CmsLesson & CmsHasLabels & CmsHasResources, void>;
export type CmsResourceResponse = CmsResource;
export type CmsLicensePoliciesResponse = CmsCollection<CmsLicensePolicy>;
export type CmsLicensePolicyResponse = CmsLicensePolicy;
export type CmsResourceIdentifierResponse = Array<CmsResourceIdentifier>;